import type { SVGProps } from 'react';

const SvgTransfer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M10 14c-.55 0-1 .45-1 1v3H5v-3c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1m10 0c-.55 0-1 .45-1 1v3h-4v-3c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1M7 13c.55 0 1-.45 1-1V7c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v2.59l-.29-.29a.996.996 0 1 0-1.41 1.41l2 2c.2.2.45.29.71.29s.51-.1.71-.29l2-2a.996.996 0 1 0-1.41-1.41l-.29.29V7c0-1.65-1.35-3-3-3h-6c-1.65 0-3 1.35-3 3v5c0 .55.45 1 1 1z"
    />
  </svg>
);
export default SvgTransfer;
